const FlagChile = ({ ...props }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ borderRadius: '100%' }}
            {...props}
        >
            <mask
                id="mask0_186_1465"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
            >
                <path
                    d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
                    fill="#C4C4C4"
                />
            </mask>
            <g mask="url(#mask0_186_1465)">
                <path d="M32.3 -0.40004H0V18.44H32.3V-0.40004Z" fill="white" />
                <path
                    d="M9.42 -0.40004H0V18.44H9.42V-0.40004Z"
                    fill="#364396"
                />
                <path
                    d="M32.3 9.01991H0V18.4399H32.3V9.01991Z"
                    fill="#C22A2A"
                />
                <path
                    d="M7.15999 5.75985L8.54 4.75984H6.81999L6.3 3.11984L5.76 4.75984H4.06L5.43999 5.75985L4.91999 7.37985L6.3 6.37984L7.67999 7.37985L7.15999 5.75985Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export default FlagChile
